import { props, formatDate } from './syllabus-block-utils';
import Block from './block';

export default {
  props,
  template: '#coursework-schedule-block-template',
  components: {
    Block
  },
  data() {
    return Object.assign({
      title: '',
      coursework: [],
      showDraftCoursework: false,
      showCourseworkNumber: true,
      showCourseworkDue: true,
      displayMode: 'list',
      displayModes: [
        'list',
        'table'
      ],

    }, this.rootData);
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.coursework);
    },
    renderableCoursework() {
      return this.coursework.filter((s) => {
        return (s.status == 'published' || this.showDraftCoursework);
      });
    },
    courseworkListLines() {
      return this.renderableCoursework.map((c) => {
        let line = c.name;
        if(this.showCourseworkNumber) {
          line = `${s.capitalize(c.family)} ${c.number}: ${line}`;
        }
        if (this.showCourseworkDue) {
          line = `${line} (${formatDate(c.due_date)})`;
        }
        return line;
      });
    },
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          showCourseworkNumber: this.showCourseworkNumber,
          showCourseworkDue: this.showCourseworkDue,
          showDraftCoursework: this.showDraftCoursework,
          displayMode: this.displayMode,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },
  },
  mounted() {
    this.coursework = this.$root.course.coursework;
  },
  methods: {
    navigateToCoursework() {
      let opts = {
        title: 'Are you sure you want to leave?',
        body: `You are about to leave the Syllabus Creator to edit your
        Coursework, any changes will be saved`,
        cancel_btn_text: 'Return To Builder',
        ok_btn_text: 'Save & Continue'
      };
      const path = Kadenze.Routes.course_coursework_index_path(this.$root.course.id);

      Kadenze.UIUtil.confirmAction(
        opts.body, () => {
          this.$root.save(() => window.location = path);
        }, null, opts
      );   
    }
  }
};
